import { functions } from 'utility/appwriteClient';

const getCarrier = async (tenant: any, shipmentCarrier: string) => {
    try {
        const carrierResponse = await functions.createExecution(
            'getCarrier',
            JSON.stringify({ tenant: tenant.toLowerCase(), carrier: shipmentCarrier })
        );

        if (!carrierResponse || !carrierResponse.response) {
            console.error("Empty response from getCarrierImage");
            return { image: '', label: shipmentCarrier };
        }

        const responseData = JSON.parse(carrierResponse.response);

        if (responseData.message === "200") {
            return {
                image: responseData.image, 
                label: responseData.label
            };
        }
    } catch (error) {
        console.error("Error fetching carrier data:", error);
    }

    return { image: '', label: shipmentCarrier };
};

const misLabelLogic = async (tenant: any, packageData: any, items: any, misData: any) => {

    const centreLogo = await functions.createExecution('misGetLogo', '{"centreId": "' + misData['CentreID'] + '"}')

    var GRPImage = ''

    if (centreLogo.response) {
        const parsedLogo = JSON.parse(centreLogo.response);
        if (parsedLogo['logoGRF'] !== undefined && parsedLogo['message'] === "200") {
            GRPImage = parsedLogo['logoGRF'];
        } else {
            GRPImage = '~DGR:DEMO.GRF,7200,24,:Z64:eJztWf';
        }
    } else {
        console.error('centreLogo.response is empty or undefined');
        GRPImage = '~DGR:DEMO.GRF,7200,24,:Z64:eJztWf';
    }
    
    var shipImage = ''

    var carrier = await getCarrier(tenant, packageData.Shipment_Carrier);
    shipImage = carrier.image;

    if (packageData.Source === 'OptimoRoute') {
        shipImage = '~DGR:SHIP.GRF,5000,25,:Z64:eJztWDtu20AQHYIFS5YpeRMzl1DjHCFIn0Iw6evYcOlaOkKqNGl4BMJwgrWz4mb2Q9qcfWOniCwE8BaGwad58+a3Goro/Rz/fHDpjALoZmASgFuOCuxXz4snYFgB5eH25vD5/PvtTScAFmPCf/UogSIClVkDTGCjNyMtElUOpCeFzajSR3OL9FHVwkoLnQpbLHGcgmrQqMYXArTHprpXqJqpx1QdNyAMkBsQVrDw7Y+oSrczkKoylYVU9VBMkKoe6AJSNXvqYIBNTy2sYEPU9oiqZQxTeTZE5S0uNaoeUZ1pQKBCFeQ4GpgSH8fla5HLXF1o2XUw8mrkMsEKHmoLs1s6ZyDV8y7J+gqPWut6rXf1cVbmY9Bun1NfMto4F6iCLwaoU6m50i7kV2+fY1Kd9G7Xc/UGFdRz9Q+p3qKC/+UXvbr7qF1S5muUWWwFVeSQG9nPzebxyp+dANStT9sTnwGkAJMGiO21vNvE0/UCmLU0JICZodWAzGKm+nsL1cfJVdWcc6iq4SpBi5brCn3wi8MIVXkAWkzXnwz0YanILYYIGEjlAUlV+3YywIK/nYm27ENahJYFPsIGgHz4nQHKrWxloXPeS6ZI1Qm1A0VgFM3u98QAPEjAb0v0lYrfFgFs4dZTHpe7AIi5aRZg0Cz2COAA5dvg2Wwh3x/b4MZSKdQm51v5aueX3RiHuHrmAA21Qi3VKVfdXgIpu77yayDWI1NL1aOvoC0zoHQdCzWZ2tQl20zt3FeZWj8arMdmav34fWQgU8uy7vnPg0w6pTFwMreUBkd2wmLR5WoTVa6WI9y5g+yEYBEu41xt+g0gfx5/NQBqwwWD1HJOfv348g0B7+cY5w/4mXI7:8CEF'
    }

    if (misData.ResellerSamples === true) {
        resellerBarcodePrinting(packageData, misData, GRPImage)
    }

    boxBarcodePrinting(packageData, items, misData, GRPImage, shipImage, carrier.label)

}


const boxBarcodePrinting = (packageData: any, items: any, misData: any, GRPImage: any, shipImage: any, carrierLabel: string) => {

    const qz = require("qz-tray")

    var token
    if (typeof window !== 'undefined') {
        token = localStorage.getItem('printer_selected')
    }

    const itemTotal = () => {
        var qtyTotal = 0

        items.map((item: any) => {
            qtyTotal = qtyTotal + parseInt(item.Package_Quantity)
        })

        return qtyTotal
    }

    const labelTotal = itemTotal()

    const boxTotal = () => {
        var qtyTotal = 0

        items.map((item: any) => {
            qtyTotal = qtyTotal + (parseInt(item.Item_Quantity) * parseInt(item.Package_Quantity))
        })

        return qtyTotal
    }

    const labelTotalQuantity = boxTotal()

    var label = ""

    const addressTwo = () => {
        if (misData.CentreDeliveryAddress.Address2 !== undefined && misData.CentreDeliveryAddress.Address2 !== null) { return misData.CentreDeliveryAddress.Address2 } else { return '' }
    }

    const customerAddressTwo = () => {
        if (packageData.Address_Line_two !== undefined && packageData.Address_Line_two !== null) { return packageData.Address_Line_two } else { return '' }
    }

    const extraOne = () => {
        if (packageData.Extra_One !== undefined && packageData.Extra_One !== null) { return packageData.Extra_One } else { return '' }
    }

    var labelCarrier = '';

    labelCarrier = carrierLabel;

    if (packageData.Shipment_Carrier === "Local Van") {
        labelCarrier = packageData.Shipment_Id
    }

    if (misData.BlindShipping === true) {

        label =
            shipImage + "^XA\n^PQ" + (labelTotal).toString() + "\n^FO20,20^FO500,100^XGR:NONE.GRF,1,1^FS\n" +
            "\n^FO20,20^FO650,800^XGR:SHIP.GRF,1,1^FS\n^FWR\n^FX Top section with logo, name and address." +
            "\n^CFA,23\n^FO560,500^FD^FS\n^CFA,23\n^FO530,500^FD^FS\n^FO500,500^FD^FS\n^FO480,50^GB3,1100,3^FS\n" +
            "^FX Second section with recipient address and permit information.\n^CFA,23\n^FO440,50^FD" + packageData.Customer_Name + "^FS\n" +
            "^FO400,50^FD" + packageData.Address_Line_One + ' ' + customerAddressTwo() + "^FS\n^FO360,50^FD" + packageData.Address_City + ' ' +
            packageData.Address_Postcode + ' ' + packageData.Address_State + "^FS\n^FO300,50^GB3,1100,3^FS\n" +
            "^FX Third section with bar code.\n^BY2,2,50\n^FO200,700\n^BC,80,Y,N,N\n^FDMISO" + misData.OrderId + ".^FS\n" +
            "^FX Fourth section PackageDetails\n^CFA,22\n^FO240,50^FDPackage:^FS\n^FO200,50^FDTotal Quantity:^FS\n^FO160,50^FDBoxes:^FS\n^FO120,50^FDRelated:^FS\n" +
            "^FO240,500^FD" + labelCarrier + "^FS\n^FO200,500^FD" + (labelTotalQuantity).toString() + "^FS\n^FO160,500^FD" + (labelTotal).toString() + "^FS\n^FO120,500^FD" + extraOne() + "^FS\n^XZ\n"

    } else {

        var lineOne = ''
        var lineTwo = ''
        var lineThree = ''

        if (misData.DeliveryType.Name == 'ToCentre') {
            lineOne = misData.OrderId
            lineTwo = misData.Description.substring(0, 70)
            lineThree = misData.CustomerOrderRef
        } else {
            lineOne = 'SHIP TO: ' + packageData.Customer_Name + ' ' + misData.CustomerOrderRef
            lineTwo = packageData.Address_Line_One + ' ' + customerAddressTwo() + ' ' + packageData.Address_City + ' ' + packageData.Address_Postcode + ' ' + packageData.Address_State
            lineThree = misData.OrderId + ' ' + misData.Description.substring(0, 80)
        }

        label =
            GRPImage + shipImage + "^XA\n^PQ" + (labelTotal).toString() + "\n^FO20,20^FO500,100^XGR:DEMO.GRF,1,1^FS\n" +
            "\n^FO20,20^FO650,800^XGR:SHIP.GRF,1,1^FS\n^FWR\n^FX Top section with logo, name and address." +
            "\n^CFA,23\n^FO590,500^FD" + misData.CentreDeliveryAddress.CompanyName + "^FS\n^CFA,23\n^FO560,500^FD" + misData.CentreDeliveryAddress.Address1 +
            "^FS\n^CFA,23\n^FO530,500^FD" + addressTwo() +
            "^FS\n^FO500,500^FD" + misData.CentreDeliveryAddress.City + ' ' + misData.CentreDeliveryAddress.Postcode + ' ' + misData.CentreDeliveryAddress.State.Abbreviation +
            "^FS\n^FO480,50^GB3,1100,3^FS\n^FX Second section with recipient address and permit information.\n^CFA,23\n^FO440,50^FD" +
            lineOne + "^FS\n" + "^FO367,50^FD^FB1200,2,3^FD" + lineTwo + "^FS\n^FO360,50^FD" + lineThree + "^FS\n^FO300,50^GB3,1100,3^FS\n" +
            "^FX Third section with bar code.\n^BY2,2,50\n^FO200,700\n^BC,80,Y,N,N\n^FDMISO" + misData.OrderId + ".^FS\n" +
            "^FX Fourth section PackageDetails\n^CFA,22\n^FO240,50^FDPackage:^FS\n^FO200,50^FDTotal Quantity:^FS\n^FO160,50^FDBoxes:^FS\n^FO120,50^FDRelated:^FS\n" +
            "^FO240,500^FD" + labelCarrier + "^FS\n^FO200,500^FD" + (labelTotalQuantity).toString() + "^FS\n^FO160,500^FD" + (labelTotal).toString() +
            "^FS\n^FO120,500^FD" + extraOne() + "^FS\n^XZ\n"

    }

    var config = qz.configs.create(token)

    qz.print(config, [label]).catch(function (e: any) { console.error(e); })

    return (
        null
    )

}


const resellerBarcodePrinting = (packageData: any, misData: any, GRPImage: any) => {

    const qz = require("qz-tray")

    var token
    if (typeof window !== 'undefined') {
        token = localStorage.getItem('printer_selected')
    }

    const addressTwo = () => {
        if (misData.CentreDeliveryAddress.Address2 !== undefined && misData.CentreDeliveryAddress.Address2 !== null) { return misData.CentreDeliveryAddress.Address2 } else { return '' }
    }

    const label =
        GRPImage + "^XA\n^PQ1\n^FO20,20^FO500,100^XGR:DEMO.GRF,1,1^FS\n^FWR\n^FX Top section with logo, name and address." +
        "\n^CFA,20\n^FO560,500^FDRESELLER SAMPLES^FS\n^CFA,20\n^FO530,500^FD" + misData.Description.substring(0, 50) +
        "^FS\n^FO500,500^FD" + misData.Description.substring(50, 100) + "^FS\n^FO480,50^GB3,1100,3^FS\n " +
        "^FX Second section with recipient address and permit information.\n^CFA,20\n^FO440,50^FD" + 'SHIP TO: ' + misData.CentreDeliveryAddress.CompanyName +
        "^FS\n^FO400,50^FD" + misData.CentreDeliveryAddress.Address1 + ' ' + addressTwo() + "^FS\n^FO360,50^FD" +
        misData.CentreDeliveryAddress.City + ' ' + misData.CentreDeliveryAddress.Postcode + ' ' + misData.CentreDeliveryAddress.State.Abbreviation + "^FS\n" +
        "^FO300,50^GB3,1100,3^FS\n ^FX Third section with bar code.\n^BY2,2,50\n^FO200,700\n^BC,80,Y,N,N\n^FDMISO" + misData.OrderId + ".^FS\n " +
        "^FO240,50^FDRESELLER LABEL^FS\n^FO200,50^FDSHIP TO CENTRE^FS\n^FO160,50^FDREF:" + misData.CustomerOrderRef + "^FS\n^XZ\n "

    var config = qz.configs.create(token)

    qz.print(config, [label]).catch(function (e: any) { console.error(e); })

    return (
        null
    )
}

const multipleLabelLogic = async (tenant: any, packageData: any, items: any, misData: any, quantity: any) => {

    const centreLogo = await functions.createExecution('misGetLogo', '{"centreId": "' + misData['CentreID'] + '"}')

    var GRPImage = ''
    
    if (centreLogo.response) {
        const parsedLogo = JSON.parse(centreLogo.response);
        if (parsedLogo['logoGRF'] !== undefined && parsedLogo['message'] === "200") {
            GRPImage = parsedLogo['logoGRF'];
        } else {
            GRPImage = '~DGR:DEMO.GRF,7200,24,:Z64:eJztWf';
        }
    } else {
        console.error('centreLogo.response is empty or undefined');
        GRPImage = '~DGR:DEMO.GRF,7200,24,:Z64:eJztWf';
    }
    
    var shipImage = ''

    var carrier = await getCarrier(tenant, packageData.Shipment_Carrier);

    shipImage = carrier.image;

    if (packageData.Source === 'OptimoRoute') {
        shipImage = '~DGR:SHIP.GRF,5000,25,:Z64:eJztWDtu20AQHYIFS5YpeRMzl1DjHCFIn0Iw6evYcOlaOkKqNGl4BMJwgrWz4mb2Q9qcfWOniCwE8BaGwad58+a3Goro/Rz/fHDpjALoZmASgFuOCuxXz4snYFgB5eH25vD5/PvtTScAFmPCf/UogSIClVkDTGCjNyMtElUOpCeFzajSR3OL9FHVwkoLnQpbLHGcgmrQqMYXArTHprpXqJqpx1QdNyAMkBsQVrDw7Y+oSrczkKoylYVU9VBMkKoe6AJSNXvqYIBNTy2sYEPU9oiqZQxTeTZE5S0uNaoeUZ1pQKBCFeQ4GpgSH8fla5HLXF1o2XUw8mrkMsEKHmoLs1s6ZyDV8y7J+gqPWut6rXf1cVbmY9Bun1NfMto4F6iCLwaoU6m50i7kV2+fY1Kd9G7Xc/UGFdRz9Q+p3qKC/+UXvbr7qF1S5muUWWwFVeSQG9nPzebxyp+dANStT9sTnwGkAJMGiO21vNvE0/UCmLU0JICZodWAzGKm+nsL1cfJVdWcc6iq4SpBi5brCn3wi8MIVXkAWkzXnwz0YanILYYIGEjlAUlV+3YywIK/nYm27ENahJYFPsIGgHz4nQHKrWxloXPeS6ZI1Qm1A0VgFM3u98QAPEjAb0v0lYrfFgFs4dZTHpe7AIi5aRZg0Cz2COAA5dvg2Wwh3x/b4MZSKdQm51v5aueX3RiHuHrmAA21Qi3VKVfdXgIpu77yayDWI1NL1aOvoC0zoHQdCzWZ2tQl20zt3FeZWj8arMdmav34fWQgU8uy7vnPg0w6pTFwMreUBkd2wmLR5WoTVa6WI9y5g+yEYBEu41xt+g0gfx5/NQBqwwWD1HJOfv348g0B7+cY5w/4mXI7:8CEF'
    }

    multipleBarcodePrinting(packageData, items, misData, GRPImage, shipImage, quantity, carrier.label)
}


const multipleBarcodePrinting = (packageData: any, items: any, misData: any, GRPImage: any, shipImage: any, quantity: any, carrierLabel: string) => {

    const qz = require("qz-tray")

    var token
    if (typeof window !== 'undefined') {
        token = localStorage.getItem('printer_selected')
    }

    const itemTotal = () => {
        var qtyTotal = 0

        qtyTotal = qtyTotal + parseInt(quantity)

        return qtyTotal
    }

    const labelTotal = itemTotal()

    const shippedTotal = () => {
        var qtyTotal = 0

        items.map((item: any) => {
            qtyTotal = qtyTotal + parseInt(item.Package_Quantity)
        })

        return qtyTotal
    }

    const labelShippedTotal = shippedTotal()

    const boxTotal = () => {
        var qtyTotal = 0

        items.map((item: any) => {
            qtyTotal = qtyTotal + (parseInt(item.Item_Quantity) * parseInt(item.Package_Quantity))
        })

        return qtyTotal
    }

    const labelTotalQuantity = boxTotal()

    var label = ""

    const addressTwo = () => {
        if (misData.CentreDeliveryAddress.Address2 !== undefined && misData.CentreDeliveryAddress.Address2 !== null) { return misData.CentreDeliveryAddress.Address2 } else { return '' }
    }

    const customerAddressTwo = () => {
        if (packageData.Address_Line_two !== undefined && packageData.Address_Line_two !== null) { return packageData.Address_Line_two } else { return '' }
    }

    const extraOne = () => {
        if (packageData.Extra_One !== undefined && packageData.Extra_One !== null) { return packageData.Extra_One } else { return '' }
    }

    var labelCarrier = '';
    
    labelCarrier = carrierLabel;

    if (packageData.Shipment_Carrier === "Local Van") {
        labelCarrier = packageData.Shipment_Id
    }

    if (misData.BlindShipping === true) {

        label =
            shipImage + "^XA\n^PQ" + (labelTotal).toString() + "\n^FO20,20^FO500,100^XGR:DEMO.GRF,1,1^FS\n" +
            "\n^FO20,20^FO650,800^XGR:SHIP.GRF,1,1^FS\n^FWR\n^FX Top section with logo, name and address." +
            "\n^CFA,23\n^FO560,500^FD^FS\n^CFA,23\n^FO530,500^FD^FS\n^FO500,500^FD^FS\n^FO480,50^GB3,1100,3^FS\n" +
            "^FX Second section with recipient address and permit information.\n^CFA,23\n^FO440,50^FD" + packageData.Customer_Name + "^FS\n" +
            "^FO400,50^FD" + packageData.Address_Line_One + ' ' + customerAddressTwo() + "^FS\n^FO360,50^FD" + packageData.Address_City + ' ' +
            packageData.Address_Postcode + ' ' + packageData.Address_State + "^FS\n^FO300,50^GB3,1100,3^FS\n" +
            "^FX Third section with bar code.\n^BY2,2,50\n^FO200,700\n^BC,80,Y,N,N\n^FDMISO" + misData.OrderId + ".^FS\n" +
            "^FX Fourth section PackageDetails\n^CFA,22\n^FO240,50^FDPackage:^FS\n^FO200,50^FDTotal Quantity:^FS\n^FO160,50^FDBoxes:^FS\n^FO120,50^FDRelated:^FS\n" +
            "^FO240,500^FD" + labelCarrier + "^FS\n^FO200,500^FD" + (labelTotalQuantity).toString() + "^FS\n^FO160,500^FD" + (labelShippedTotal).toString() + "^FS\n^FO120,500^FD" + extraOne() + "^FS\n^XZ\n"

    } else {

        var lineOne = ''
        var lineTwo = ''
        var lineThree = ''

        if (misData.DeliveryType.Name == 'ToCentre') {
            lineOne = misData.OrderId
            lineTwo = misData.Description.substring(0, 70)
            lineThree = misData.CustomerOrderRef
        } else {
            lineOne = 'SHIP TO: ' + packageData.Customer_Name + ' ' + misData.CustomerOrderRef
            lineTwo = packageData.Address_Line_One + ' ' + customerAddressTwo() + ' ' + packageData.Address_City + ' ' + packageData.Address_Postcode + ' ' + packageData.Address_State
            lineThree = misData.OrderId + ' ' + misData.Description.substring(0, 80)
        }

        label =
            GRPImage + shipImage + "^XA\n^PQ" + (labelTotal).toString() + "\n^FO20,20^FO500,100^XGR:DEMO.GRF,1,1^FS\n" +
            "\n^FO20,20^FO650,800^XGR:SHIP.GRF,1,1^FS\n^FWR\n^FX Top section with logo, name and address." +
            "\n^CFA,23\n^FO590,500^FD" + misData.CentreDeliveryAddress.CompanyName + "^FS\n^CFA,23\n^FO560,500^FD" + misData.CentreDeliveryAddress.Address1 +
            "^FS\n^CFA,23\n^FO530,500^FD" + addressTwo() +
            "^FS\n^FO500,500^FD" + misData.CentreDeliveryAddress.City + ' ' + misData.CentreDeliveryAddress.Postcode + ' ' + misData.CentreDeliveryAddress.State.Abbreviation +
            "^FS\n^FO480,50^GB3,1100,3^FS\n^FX Second section with recipient address and permit information.\n^CFA,23\n^FO440,50^FD" +
            lineOne + "^FS\n" + "^FO367,50^FD^FB1200,2,3^FD" + lineTwo + "^FS\n^FO360,50^FD" + lineThree + "^FS\n^FO300,50^GB3,1100,3^FS\n" +
            "^FX Third section with bar code.\n^BY2,2,50\n^FO200,700\n^BC,80,Y,N,N\n^FDMISO" + misData.OrderId + ".^FS\n" +
            "^FX Fourth section PackageDetails\n^CFA,22\n^FO240,50^FDPackage:^FS\n^FO200,50^FDTotal Quantity:^FS\n^FO160,50^FDBoxes:^FS\n^FO120,50^FDRelated:^FS\n" +
            "^FO240,500^FD" + labelCarrier + "^FS\n^FO200,500^FD" + (labelTotalQuantity).toString() + "^FS\n^FO160,500^FD" + (labelShippedTotal).toString() +
            "^FS\n^FO120,500^FD" + extraOne() + "^FS\n^XZ\n"

    }

    var config = qz.configs.create(token)

    qz.print(config, [label]).catch(function (e: any) { console.error(e); })

    return (
        null
    )

}

export { misLabelLogic, multipleLabelLogic }